/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { CircularProgress } from '@mui/material';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './components/redux/store';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { SocketProvider } from './components/redux/socketProvider';
import { ConfigProvider } from 'antd';
import AppLoader from './components/common/AppLoader';
const App = lazy(() => import('./App'))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<AppLoader text="Initializing BINS APP..." />}>
    <React.StrictMode>
      <Provider store={store}>
        <SocketProvider>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#0EBE3C',
                borderRadius: 16,
              },
            }}
          >
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ConfigProvider>
        </SocketProvider>
      </Provider>
    </React.StrictMode>
  </Suspense>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
